import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const JiamidWorld = () => import(/* webpackChunkName: "world" */ '../views/JiamidWorld.vue')
const McdPage = () => import(/* webpackChunkName: "mcd" */ '../views/McdPage.vue')
const TarotPage = () => import(/* webpackChunkName: "tarot" */ '../views/TarotPage.vue')
const Tools = () => import(/* webpackChunkName: "tools" */ '../views/Tools.vue')
const NotFound = () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/tools',
    name: 'Tools',
    component: Tools,
    meta: { requiresAuth: false }
  },
  {
    path: '/jiamid-world',
    name: 'JiamidWorld',
    component: JiamidWorld,
    meta: { requiresAuth: true }
  },
  {
    path: '/mcd',
    name: 'Mcd',
    component: McdPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/tarot',
    name: 'Tarot',
    component: TarotPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    next('/')
    return
  }
  next()
})

export default router
